import { render, staticRenderFns } from "./StudentSelectorFields.vue?vue&type=template&id=9787cc0c&"
import script from "./StudentSelectorFields.vue?vue&type=script&lang=js&"
export * from "./StudentSelectorFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports